export class BalanceImportModel {
  counter: number = 0;
  branchId: number = 0; 
  dateBalances: Date = new Date;
  costCenterCode:number = 0;
  articleCode: number = 0;
  storeCode: number = 0;
  quantity: number = 0;
  unitValue: number = 0;
  constructor(counter: number,
    branchId: number,
    dateBalances: Date,
    costCenterCode: number,
    articleCode: number,
    storeCode: number,
    quantity: number,
    unitValue: number ){
    this.counter = counter;
    this.branchId = branchId;
    this.dateBalances = dateBalances;
    this.costCenterCode = costCenterCode;
    this.articleCode = articleCode;
    this.storeCode = storeCode;
    this.quantity = quantity;
    this.unitValue = unitValue;
  }
}